import { render, staticRenderFns } from "./infoBox.vue?vue&type=template&id=37c85ec0&scoped=true&"
import script from "./infoBox.vue?vue&type=script&lang=js&"
export * from "./infoBox.vue?vue&type=script&lang=js&"
import style0 from "./infoBox.vue?vue&type=style&index=0&id=37c85ec0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c85ec0",
  null
  
)

export default component.exports